import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 10
	})
});
export default SvgDot;
